export const MULTAS_SII_MODULE_ID = 'multas_sii'

export { defaultConfiguracionEquipoAccess as defaultMultasSiiAccess } from './configuracionEquipoModule'
